import {Component, HostListener, OnInit} from '@angular/core';
import {JwtService, OauthService} from 'mclane-webauth-lib';
import {ClientService} from '~/app/core/services/client.service';
import {LoggingService} from 'mclane-apptemplate-lib';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    deferredPrompt: any;
    showButton = false;
    loggedIn = false;
    applications = [];
    events = [];

    constructor(
        public jwtService: JwtService,
        public oauthService: OauthService,
        public clientService: ClientService,
        public console: LoggingService) {

    }

    buildHomeDivs(currentAccessItemsForUser) {
        this.console.log(currentAccessItemsForUser);
        for (let count = 0; count < currentAccessItemsForUser.length; count++) {
            const currentItem = currentAccessItemsForUser[count];
            const tempItem = {text: currentItem.name, url: currentItem.baseUrl, image: currentItem.originalName};
            this.applications.push(tempItem);
        }
    }

    ngOnInit() {
        if (this.jwtService.isLoggedIn()) {
            this.clientService.getClients().toPromise().then(async (result) => {
                const sortedClients = this.clientService.getUserRoles(result);
                await this.buildHomeDivs(sortedClients);
            });
            this.loggedIn = true;
        }
    }

    @HostListener('window:beforeinstallprompt', ['$event'])
    onbeforeinstallprompt(e) {
        this.console.log(e);
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
        this.showButton = true;
    }
}
